import Aside from "./components/layout/Aside";
import Main from "./components/layout/Main";
import LoadScripts from "./components/app/LoadScripts";
import HashScrollHandler from "./components/app/HashScrollHandler";
import ErrorBoundary from "./components/app/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div id="colorlib-page">
        <div className="container-wrap">
          <Aside />
          <div id="colorlib-main">
            <Main />
          </div>
        </div>
      </div>
      <HashScrollHandler />
      <LoadScripts />
    </ErrorBoundary>
  );
}

export default App;
